var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "38px",
    height: "26px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "38px",
    height: "26px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaAgMAAACm68brAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEVbf5Vbf5X///8sD1RiAAAAAnRSTlMAesZDVRoAAAABYktHRAJmC3xkAAAAB3RJTUUH6AIUEwgStnhGjgAAABtJREFUGNNjCIWBAIasVVAwgTATSRspYIjZBgA01l9HTLV/egAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5f47f820036fbe45c51edd7698a91f7b.svg";
export { ForwardRef as ReactComponent };